import {decipher} from "../../utils/simpleCrypto";

export default async function isPro(fetch) {
    const resp = await fetch('/graphql', {
        body: JSON.stringify({
            query: '{me{id, email, p}}',
        }),
    });

    const { data } = await resp.json();
    if (!data || !data.me) throw new Error('Failed to load the user.');

    const user = data.me;
    const d = decipher(user.id + user.email);

    if (!user.p) {
        return false;
    }

    return d(user.p) === 'jUkkA';
}